import { differenceInYears, parseISO } from 'date-fns'

export const formatAge = (birthDate: string | null | undefined) => {
  return birthDate
    ? `${differenceInYears(new Date(), parseISO(birthDate))}`
    : '-'
}
